import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import APIURL from "../api/apiClient";

const AuthWrapper = ({ children }) => {
  const [authChecked, setAuthChecked] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const localRole = localStorage.getItem("userRole");

    // ✅ Prevent flicker: handle known local role immediately
    if (localRole) {
      if (
        localRole === "staff" &&
        !["/staffscreen", "/updateitemscsv"].includes(location.pathname)
      ) {
        navigate("/staffscreen", { replace: true });
        return;
      }
      if (
        localRole !== "staff" &&
        ["/staffscreen",].includes(location.pathname)
      ) {
        navigate("/not-authorized", { replace: true });
        return;
      }
    }

    const checkSession = async () => {
      try {
        const response = await axios.get(`${APIURL.baseURL}/session.php`, {
          withCredentials: true,
        });

        const { loggedIn, role, username } = response.data;

        if (loggedIn) {
          localStorage.setItem("userRole", role);
          localStorage.setItem("username", username);

          // ✅ Staff-only allowed routes
          if (role === "staff") {
            if (!["/staffscreen", "/updateitemscsv"].includes(location.pathname)) {
              navigate("/staffscreen", { replace: true });
              return;
            }
          } else {
            // ✅ Non-staff login handling
            if (["/", "/login", "/register"].includes(location.pathname)) {
              navigate("/home", { replace: true });
              return;
            }
            if (["/staffscreen",].includes(location.pathname)) {
              navigate("/not-authorized", { replace: true });
              return;
            }
          }
        } else {
          // ❌ Not logged in
          localStorage.removeItem("userRole");
          localStorage.removeItem("username");

          if (!["/", "/login", "/register"].includes(location.pathname)) {
            navigate("/login", { replace: true });
            return;
          }
        }
      } catch (error) {
        console.error("Session check error:", error);
        localStorage.removeItem("userRole");
        localStorage.removeItem("username");
        navigate("/login", { replace: true });
      } finally {
        setAuthChecked(true);
        setLoading(false);
      }
    };

    checkSession();
  }, [navigate, location.pathname]);

  // ✅ Show loader until session verified
  if (loading || !authChecked) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return children;
};

export default AuthWrapper;
